import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <main className="min-h-screen bg-slate-50 text-slate-900">
      <div className="mx-auto max-w-4xl px-6 py-12">
        <h1 className="text-3xl font-semibold">Privacy Policy</h1>
        <p className="mt-2 text-sm text-slate-600">Last updated: February 26, 2026</p>

        <div className="mt-8 space-y-6 text-sm leading-7 text-slate-700">
          <section>
            <h2 className="text-lg font-semibold text-slate-900">1. Data We Collect</h2>
            <p>
              We collect account information, integration tokens, and analytics data required to provide social media
              connection, publishing, and reporting features.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">2. How We Use Data</h2>
            <p>
              Data is used to authenticate users, connect authorized social accounts, display analytics, and execute
              user-requested actions such as synchronization and publishing.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">3. Third-Party APIs</h2>
            <p>
              When you connect a platform, we process tokens and profile data from that provider according to their API
              terms and your granted permissions.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">4. Security</h2>
            <p>
              We apply technical and organizational controls to protect stored data and credentials. Access is limited
              to authorized users and operational requirements.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">5. Data Retention & Rights</h2>
            <p>
              We retain data for service operation and compliance needs. You may request account disconnection or data
              removal through support channels, subject to legal obligations.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900">6. Contact</h2>
            <p>
              For privacy requests, contact{" "}
              <a className="text-blue-600 underline" href="mailto:privacy@migrahosting.com">
                privacy@migrahosting.com
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-10 border-t border-slate-200 pt-6 text-sm">
          <Link to="/login" className="text-blue-600 underline">
            Back to Login
          </Link>
        </div>
      </div>
    </main>
  );
}
